import { useFormContext } from "react-hook-form";
import { Grid } from "@mui/material";
import { BorderedFormGrid } from "../../../../Forms/BorderedFormGrid";
import { TTProtection } from "../../TTProtection";
import { TtProtectionFilterProps } from "./TtProtectionFilterProps";
import { RHFAutoCompleteWithDebouncedFetch } from "./MultiSelectMenues/RHFAutoCompleteWithDebouncedFetch";
import { ttProtectionFilterUrls } from "../../../../URL/ApplicationUrls";
import { TtProtectionMultiSelect } from "./MultiSelectMenues/TtProtectionMultiSelect";
import { useFetchOdcsAndCrossDocks } from "./Hooks/useFetchOdcsAndCrossDocks";
import { RhfAutoComplete } from "./RhfAutoComplete";

export const OtherCriteriaFilters = ({ selectedFilters }: TtProtectionFilterProps) => {
  const { control } = useFormContext<TTProtection>();

  const { data: odcsAndCrossDocks } = useFetchOdcsAndCrossDocks(
    ttProtectionFilterUrls.odcsAndCrossDocks
  );

  return (
    <BorderedFormGrid subformName="Other Criteria">
      <Grid item xs={12}>
        <RhfAutoComplete
          control={control}
          name="TtProtectionFilters.OdcGsdbs"
          label="ODC / Cross Dock"
          options={odcsAndCrossDocks ?? []}
        />
      </Grid>
      <Grid item xs={12}>
        <TtProtectionMultiSelect
          name="TtProtectionFilters.CrossingCountryIds"
          control={control}
          apiUrl={ttProtectionFilterUrls.crossingCountries}
          errorMessage="An error occurred when retrieving the Crossing Countries"
          label="Crossing Countries"
        />
      </Grid>
      <Grid item xs={12}>
        <RHFAutoCompleteWithDebouncedFetch
          control={control}
          name="TtProtectionFilters.FtlRouteNumbers"
          label="FTL Routes"
          initialFilters={selectedFilters?.FtlRouteNumbers}
          apiUrl={ttProtectionFilterUrls.ftlRoutes}
          errorMessage="An error occurred when retrieving the FTL routes"
        />
      </Grid>
    </BorderedFormGrid>
  );
};
